import { render } from "react-dom";

import { SiteSearch } from "./SiteSearch";

(() => {
  const searchContainer = document.getElementById("search-container");
  const searchFiltersData = JSON.parse(
    document.getElementById("search-page")?.dataset?.filters || "null"
  );

  if (searchContainer && searchFiltersData) {
    render(
      <SiteSearch searchFiltersData={searchFiltersData} />,
      searchContainer
    );
  }
})();
